module.exports = __webpack_public_path__ + "media/images/city_img/d_1-0b953495440bd461b4ac6c436a364609.jpg";